import React from 'react'
import LogoImg from '../../assets/Logo.webp'

export default function Logo() {
	return <img src={LogoImg} alt="AvaxWildlife" />
}
